import store from '../../../store'
import imc_auth from './auth.vue';

window.IMC_AUTH =  new Vue({
	store,
	el: '#imc_auth',
	name : 'IMC_AUTH',
	data () {
		return {
			showModal: false,
		}
	},
	created () {

	},
	components : {
		imc_auth
	}
})
